import { RiskScoreColor } from 'common/constants/TaxonomyConstants';

import styles from './RiskTaxonomyHeatMap.module.scss';

const { heatmapRed, heatmapYellow, heatmapGreen } = styles;
const BORDER_WIDTH = '6px';
const BORDER_STYLE = 'solid';

export const getBorderColorClass = (score: string): string => {
	switch (score) {
		case RiskScoreColor.RiskScoreRed:
			return `${BORDER_WIDTH} ${BORDER_STYLE} ${heatmapRed}`;
		case RiskScoreColor.RiskScoreYellow:
			return `${BORDER_WIDTH} ${BORDER_STYLE} ${heatmapYellow}`;
		default:
			return `${BORDER_WIDTH} ${BORDER_STYLE} ${heatmapGreen}`;
	}
};
